

/*
 * Search toggles
 */

var $biro_header_search_form;
var $biro_header_search_toggle;

// On page load
jQuery( function( $ ) {

	// Init
	$biro_header_search_form   = $( '.search-form-wrap-header' );
	$biro_header_search_toggle = $( '.header-search-toggle' );

	// Desktop search toggle
	$biro_header_search_toggle.on( 'click', function() {

		if ( $biro_header_search_toggle.attr( 'aria-expanded' ) === 'false' ) {

			// Close any open menus
			$biro_header_menu.find( '[aria-expanded="true"]' ).attr( 'aria-expanded', 'false' );

			// Open form
			biro_search_form_open();

		} else {

			// Close form
			biro_search_form_close();

		}

	});

});


/**
 * Open search form
 */
function biro_search_form_open() {
	if ( $biro_header_search_toggle.attr( 'aria-expanded' ) === 'false' ) {
		$biro_header_search_form.fadeIn(
			200,
			function() {
				$biro_header_search_toggle.attr( 'aria-expanded', 'true' );
				$biro_header_search_form.find( '.search-text' ).focus();
			}
		);
	}
}


/**
 * Close search form
 */
function biro_search_form_close() {
	if ( $biro_header_search_toggle.attr( 'aria-expanded' ) === 'true' ) {
		$biro_header_search_form.fadeOut(
			200,
			function() {
				$biro_header_search_toggle.attr( 'aria-expanded', 'false' ).blur();
			}
		);
	}
}